"use client";

import Image from "next/image";

import { TherapyCallPreview } from "~/components/homepage/therapy-call-preview";
import { useResolvedMediaQuery } from "~/components/patterns/stepper/use-media-query";

export function ResponsiveTherapyCallPreview() {
  const { value: isDesktop, isResolved } =
    useResolvedMediaQuery("(min-width: 768px)");

  if (!isResolved) {
    return (
      <div
        className="relative left-[3vw] w-[105vw] pt-[25.2rem] md:aspect-video md:w-full md:pt-0"
        aria-hidden
      >
        <div className="aspect-[936/1681] md:hidden" />
      </div>
    );
  }

  const preview = (
    <TherapyCallPreview layout="fill" surface="transparent" autoPlay />
  );

  if (!isDesktop) {
    return (
      <div className="relative left-[3vw] mx-auto w-[105vw] pt-[25.2rem]">
        <div className="relative aspect-[936/1681] w-full">
          <div className="absolute top-[8%] left-[19.5%] z-10 h-[68%] w-[61%] overflow-hidden rounded-[5%/3%] bg-slate-950">
            {preview}
          </div>
          <Image
            src="/images/landing/homepage-mobile-approved-phone.webp"
            alt=""
            fill
            sizes="105vw"
            className="pointer-events-none z-20 object-contain"
            loading="eager"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-[72vw] max-w-4xl xl:w-full">
      <div className="border-brand-ink border-b-brand-forest bg-brand-ink relative -top-[4px] z-10 rounded-t-[18px] border-x-[12px] border-t-[16px] border-b-[14px] shadow-[0_8px_18px_rgba(0,0,0,0.2)] sm:border-x-[15px] sm:border-t-[18px] sm:border-b-[16px]">
        <span
          aria-hidden="true"
          className="bg-brand-forest absolute top-[-12px] left-1/2 h-1.5 w-1.5 -translate-x-1/2 rounded-full ring-1 ring-white/25 sm:top-[-13px]"
        />
        <span
          aria-hidden="true"
          className="absolute bottom-[-12px] left-1/2 h-0.5 w-8 -translate-x-1/2 rounded-full bg-white/20"
        />
        <div className="bg-editorial-paper overflow-hidden rounded-[4px] ring-1 ring-white/15">
          <div className="border-brand-forest/15 flex h-10 items-center border-b px-4">
            <div className="flex gap-1.5" aria-hidden="true">
              <span className="bg-brand-forest/20 h-2.5 w-2.5 rounded-full" />
              <span className="bg-brand-forest/20 h-2.5 w-2.5 rounded-full" />
              <span className="bg-brand-forest/20 h-2.5 w-2.5 rounded-full" />
            </div>
            <span className="border-brand-forest/10 bg-background text-foreground/50 mx-auto rounded-md border px-20 py-1 text-xs">
              resimoprobleme.com/app
            </span>
            <span className="w-12" aria-hidden="true" />
          </div>
          <div className="aspect-video">{preview}</div>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none relative left-1/2 z-0 -mt-5 aspect-[4.2/1] w-[132%] -translate-x-1/2"
      >
        <Image
          src="/images/landing/homepage-laptop-base-illustrated.webp"
          alt=""
          fill
          sizes="(max-width: 1279px) 96vw, 1183px"
          className="object-fill"
        />
      </div>
    </div>
  );
}
